import React, { FC, ReactNode } from "react";
import {
  INTAKE_PAGE_BACKGROUND_IMAGE,
  INTAKE_PAGE_BACKGROUND_SIZE
} from "../../foreignNationalOutgoingIntakes/components/intakePageBackground";
import { DraftCornerTicks } from "../../foreignNationalOutgoingIntakes/components/drafting";

type Props = {
  children: ReactNode;
};

/**
 * Floating table card on the grid-paper client-portal background. Carries the
 * same crop marks as the review screen's status sheet, so a table reads as one
 * more drawing pinned to the same canvas.
 */
export const ClientPortalFloatingTableShell: FC<Props> = ({ children }) => {
  return (
    <div
      className="flex min-h-0 w-full flex-1 flex-col bg-primary-light p-4 md:p-6"
      style={{
        backgroundImage: INTAKE_PAGE_BACKGROUND_IMAGE,
        backgroundSize: INTAKE_PAGE_BACKGROUND_SIZE
      }}
    >
      <div className="relative flex min-h-0 w-full flex-1 flex-col rounded-md border border-solid border-line-2 bg-background shadow-sm">
        <DraftCornerTicks />
        {/* Clipping lives on an inner layer so the ticks can sit on the edge. */}
        <div className="flex min-h-0 w-full flex-1 flex-col overflow-hidden rounded-md">
          {children}
        </div>
      </div>
    </div>
  );
};
